package com.sweetlime.dungeonamigo.cache.shared

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.sweetlime.dungeonamigo.cache.SrdDatabase
import com.sweetlime.dungeonamigo.cache.SrdDatabaseQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<SrdDatabase>.schema: SqlSchema<QueryResult.Value<Unit>>
  get() = SrdDatabaseImpl.Schema

internal fun KClass<SrdDatabase>.newInstance(driver: SqlDriver): SrdDatabase =
    SrdDatabaseImpl(driver)

private class SrdDatabaseImpl(
  driver: SqlDriver,
) : TransacterImpl(driver), SrdDatabase {
  override val srdDatabaseQueries: SrdDatabaseQueries = SrdDatabaseQueries(driver)

  public object Schema : SqlSchema<QueryResult.Value<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.Value<Unit> {
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS spells (
          |    slug TEXT NOT NULL PRIMARY KEY,
          |    name TEXT NOT NULL,
          |    level TEXT,
          |    school TEXT,
          |    casting_time TEXT,
          |    range TEXT,
          |    duration TEXT,
          |    components TEXT,
          |    material TEXT,
          |    description TEXT,
          |    higher_level TEXT,
          |    classes TEXT,
          |    ritual TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS monsters (
          |    slug TEXT NOT NULL PRIMARY KEY,
          |    name TEXT NOT NULL,
          |    size TEXT,
          |    type TEXT,
          |    alignment TEXT,
          |    armor_class INTEGER,
          |    hit_points INTEGER,
          |    hit_dice TEXT,
          |    speed TEXT,
          |    challenge_rating TEXT,
          |    description TEXT,
          |    actions TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS items (
          |    slug TEXT NOT NULL PRIMARY KEY,
          |    name TEXT NOT NULL,
          |    type TEXT,
          |    rarity TEXT,
          |    requires_attunement TEXT,
          |    description TEXT,
          |    cost TEXT,
          |    weight TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS sync_meta (
          |    category TEXT NOT NULL PRIMARY KEY,
          |    synced_at INTEGER NOT NULL,
          |    total_count INTEGER NOT NULL
          |)
          """.trimMargin(), 0)
      return QueryResult.Unit
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.Value<Unit> = QueryResult.Unit
  }
}
